var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColteneLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155.557,
    height: 47.82,
    viewBox: "0 0 155.557 47.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coltene_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5277",
    "data-name": "Group 5277",
    transform: "translate(-912 -262.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M31.947,9.348V9.295A9.135,9.135,0,0,1,41.32,0a9.276,9.276,0,0,1,7.088,2.773l-2.517,2.9a6.631,6.631,0,0,0-4.6-2.03,5.326,5.326,0,0,0-5.213,5.6v.05c0,3.082,2.131,5.651,5.213,5.651a6.492,6.492,0,0,0,4.725-2.1l2.516,2.541a9.184,9.184,0,0,1-7.37,3.21,9.073,9.073,0,0,1-9.219-9.245",
    transform: "translate(908.22 262.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M53.8,9.348V9.295a9.557,9.557,0,0,1,19.105-.05v.05A9.557,9.557,0,0,1,53.8,9.348m14.97,0V9.295a5.461,5.461,0,0,0-5.443-5.649,5.376,5.376,0,0,0-5.393,5.6v.05a5.462,5.462,0,0,0,5.444,5.651,5.375,5.375,0,0,0,5.392-5.6",
    transform: "translate(905.635 262.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M80.1.349h3.955v14.38h8.962v3.6H80.1Z",
    transform: "translate(902.523 262.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M100.614,4H95.143V.349h14.9V4h-5.472V18.325h-3.954Z",
    transform: "translate(900.744 262.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M116.638.349H130.2V3.867h-9.63V7.514h8.472v3.518h-8.472v3.775h9.757v3.519H116.638Z",
    transform: "translate(898.201 262.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M137.345.349h3.647l8.422,11.068V.349h3.9V18.326h-3.365L141.249,6.9V18.326h-3.9Z",
    transform: "translate(895.751 262.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M160.9.349h13.56V3.867h-9.631V7.514h8.475v3.518h-8.475v3.775h9.759v3.519H160.9Z",
    transform: "translate(892.964 262.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M6.044,11.3,2.22,19.358H7.244L11.066,11.3Z",
    transform: "translate(911.737 261.426)",
    fill: "#00a4e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M13.245,11.3,9.42,19.358h5.025L18.266,11.3Z",
    transform: "translate(910.886 261.426)",
    fill: "#57c1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M20.446,11.3l-3.825,8.058h5.025L25.468,11.3Z",
    transform: "translate(910.034 261.426)",
    fill: "#acdefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M3.825.8,0,8.856H5.025L8.846.8Z",
    transform: "translate(912 262.668)",
    fill: "#0090df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M11.025.8,7.2,8.856h5.025L16.046.8Z",
    transform: "translate(911.148 262.668)",
    fill: "#0090df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M18.227.8,14.4,8.856h5.025L23.249.8Z",
    transform: "translate(910.296 262.668)",
    fill: "#0090df"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5531",
    "data-name": "Group 5531",
    transform: "translate(0 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M33.45,49.348a6.047,6.047,0,0,0,3.357,1.009c1.785,0,3.427-1.055,3.427-2.957,0-1.174-.657-2.066-2.323-2.957-2.019-1.1-3.146-2.371-3.146-4.061,0-2.84,2.441-4.647,5.352-4.647a5.956,5.956,0,0,1,3.239.822l-.7,1.6a5.35,5.35,0,0,0-2.746-.751,2.838,2.838,0,0,0-3.122,2.582c0,1.292.8,2.019,2.464,2.935,1.949,1.055,3,2.3,3,4.248,0,2.723-2.136,4.883-5.7,4.883a6.606,6.606,0,0,1-3.8-1.1Z",
    transform: "translate(908.126 258.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M53.684,51.918a7.424,7.424,0,0,1-3.286.7,4.081,4.081,0,0,1-4.366-4.389c0-3.874,2.864-7.441,6.948-7.441a5.792,5.792,0,0,1,2.371.493l-.563,1.549a4.428,4.428,0,0,0-1.925-.422c-2.958,0-4.813,2.91-4.813,5.586,0,1.831.963,3.028,2.817,3.028a5.887,5.887,0,0,0,2.629-.634Z",
    transform: "translate(906.554 257.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M57.107,51.821,59.29,40.46h1.926L59.056,51.821Zm2.536-14.506A1.3,1.3,0,0,1,60.911,36a1.147,1.147,0,0,1,1.174,1.22,1.289,1.289,0,0,1-1.338,1.315,1.106,1.106,0,0,1-1.1-1.22",
    transform: "translate(905.244 258.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M75.574,51.34a10.467,10.467,0,0,1-4.108.7c-5.024,0-8.075-3.146-8.075-7.981,0-5.211,3.638-8.357,8.473-8.357a8.955,8.955,0,0,1,3.827.7l-.61,2.3a7.773,7.773,0,0,0-3.1-.61c-3.216,0-5.54,2.019-5.54,5.821,0,3.5,2.019,5.7,5.517,5.7a8.781,8.781,0,0,0,3.146-.563Z",
    transform: "translate(904.5 258.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M88.4,49.629a15.389,15.389,0,0,0,.188,2.746H85.981l-.211-1.267H85.7a4.175,4.175,0,0,1-3.38,1.525,3.394,3.394,0,0,1-3.592-3.4c0-2.864,2.559-4.342,6.784-4.319v-.188c0-.751-.305-2-2.323-2a6.052,6.052,0,0,0-3.075.846L79.55,41.7a8.231,8.231,0,0,1,4.132-1.01c3.661,0,4.718,2.324,4.718,4.835Zm-2.817-2.84c-2.042-.024-3.991.4-3.991,2.136a1.515,1.515,0,0,0,1.643,1.643A2.372,2.372,0,0,0,85.512,49a1.95,1.95,0,0,0,.071-.635Z",
    transform: "translate(902.686 257.949)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M93.146,44.348c0-1.315-.048-2.418-.094-3.4h2.512l.14,1.713h.071a4.2,4.2,0,0,1,3.662-1.971c2,0,4.061,1.291,4.061,4.906v6.784H100.61V45.921c0-1.643-.609-2.888-2.182-2.888a2.423,2.423,0,0,0-2.254,1.69,2.669,2.669,0,0,0-.141.915v6.737H93.146Z",
    transform: "translate(900.991 257.949)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3263",
    "data-name": "Rectangle 3263",
    width: 155.557,
    height: 47.82,
    transform: "translate(912 262.763)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColteneLogo);
export default __webpack_public_path__ + "static/media/coltene_logo.b730d22f235b2e05ac2d774c2c3f4036.svg";
export { ForwardRef as ReactComponent };